import {
    LIST_TURNS,
    LIST_TURNS_SUCCESS,
    LIST_TURNS_ERROR,
    ADD_TURNS,
    SAVE_TURNS,
    SAVE_TURNS_SUCCESS,
    SAVE_TURNS_ERROR,
    DELETE_TURNS,
    DELETE_TURNS_SUCCESS,
    DELETE_TURNS_ERROR,
    EDIT_TURNS,
    UPDATE_TURNS,
    UPDATE_TURNS_SUCCESS,
    UPDATE_TURNS_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import turnsData from '../data/turns';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS, MSG_ERROR_SERVER } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'turno';

//LISTAR TURNS
export function listTurnsAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listTurns() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const turns = response.data;
            //Llamo al dispatch
            dispatch( listTurnsSuccess(turns) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listTurnsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listTurns = () => ({
    type: LIST_TURNS,
    payload: true
});

const listTurnsSuccess = turns => ({
    type: LIST_TURNS_SUCCESS,
    payload: turns
});

const listTurnsError = error => ({
    type: LIST_TURNS_ERROR,
    payload: error
});

//ADD AUDIENCE CATEGORY
export function addTurnsAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addTurns(false) );
        //Abro el formulario
        showForm();
    }
}

const addTurns = isEdit => ({
    type: ADD_TURNS,
    payload: isEdit
});

//SAVE AUDIENCE CATEGORY
export function saveTurnsAction(turn, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveTurns() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, turn);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveTurnsSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveTurnsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveTurns = () => ({
    type: SAVE_TURNS,
    payload: true
});


const saveTurnsSuccess = turn => ({
    type: SAVE_TURNS_SUCCESS,
    payload: turn
});

const saveTurnsError = error => ({
    type: SAVE_TURNS_ERROR,
    payload: error
});

//EDIT AUDIENCE CATEGORY
export function editTurnsAction(turn, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editTurns(turn) );
        //Abro el formulario
        showForm();
    }
}

const editTurns = turn => ({
    type: EDIT_TURNS,
    payload: turn
});

//UPDATE AUDIENCE CATEGORY
export function updateTurnsAction(turn, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateTurns() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${turn.id}`, turn);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateTurnsSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateTurnsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateTurns = () => ({
    type: UPDATE_TURNS,
    payload: true
});

const updateTurnsSuccess = turn => ({
    type: UPDATE_TURNS_SUCCESS,
    payload: turn
});

const updateTurnsError = error => ({
    type: UPDATE_TURNS_ERROR,
    payload: error
});

//DELETE AUDIENCE CATEGORY
export function deleteTurnsAction(turn) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteTurns() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${turn.id}`);
            const response = await clienteAxios.put(`/${controller}/${turn.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteTurnsSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteTurnsError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteTurns = () => ({
    type: DELETE_TURNS,
    payload: true
});

const deleteTurnsSuccess = turn => ({
    type: DELETE_TURNS_SUCCESS,
    payload: turn
});

const deleteTurnsError = error => ({
    type: DELETE_TURNS_ERROR,
    payload: error
});